<script>
    import StepsProgressBar from '../common/sidebar/StepsProgressBar.svelte'
    import AppComponent from '../common/AppComponent.svelte'
    import DownloadPage from "./DownloadPage.svelte"
</script>

<StepsProgressBar currentPage={6}/>
<AppComponent previousPage="#/quote">
    <DownloadPage/>
</AppComponent>
